import { TabStyles } from '@tableau/widgets';
import { cssClass } from '../../../style';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { Omit } from '../../../ts/helpers/TypescriptHelpers';
import { IModalOptions, ModalSize, ModalType } from '../../../ts/services/ModalService';

export const DetailsPaneWhiteBackground = cssClass('content', 'details-dialog-contents', {
  $nest: {
    '& .tb-details': {
      backgroundColor: TabStyles.Colors.White
    }
  }
});

function getBaseAngularDetailsDialogOptions(angularContext: AngularContext): Omit<IModalOptions, 'templateUrl'> {
  return {
    type: ModalType.Normal, // Unification has the title bar but doesn't play nice with the padding override

    // tb-modal-external-content sets padding to 0, because the details pane HTML has its own padding
    classes: `tb-modal-external-content ${DetailsPaneWhiteBackground}`,

    size: ModalSize.fitToContent,
    scope: angularContext.scope
  };
}

export function getAngularProjectDetailDialogOptions(angularContext: AngularContext): IModalOptions {
  return {
    ...getBaseAngularDetailsDialogOptions(angularContext),
    templateUrl: 'projectSettingsDialog.html',
  };
}

export function getAngularWorkbookDetailDialogOptions(angularContext: AngularContext): IModalOptions {
  return {
    ...getBaseAngularDetailsDialogOptions(angularContext),
    templateUrl: 'workbookSettingsDialog.html',
  };
}

export function getAngularDatasourceDetailDialogOptions(angularContext: AngularContext): IModalOptions {
  return {
    ...getBaseAngularDetailsDialogOptions(angularContext),
    templateUrl: 'datasourceSettingsDialog.html',
  };
}
